var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeb3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.603.906a.8.8 0 01.794 0l1.4.8a.8.8 0 01-.794 1.39L7 2.521l-1.003.573a.8.8 0 01-.794-1.389l1.4-.8zM3.495 3.604a.8.8 0 01-.298 1.091l-.184.106.184.105a.8.8 0 01-.794 1.39L2.2 6.178v.222a.8.8 0 11-1.6 0V4.8a.797.797 0 01.417-.703l1.386-.792a.8.8 0 011.092.298zM10.505 3.604a.8.8 0 011.092-.298l1.386.792a.8.8 0 01.417.703v1.6a.8.8 0 01-1.6 0v-.222l-.203.116a.8.8 0 11-.794-1.389l.185-.105-.185-.106a.8.8 0 01-.298-1.091zM4.905 6.804a.8.8 0 011.092-.298L7 7.08l1.003-.573a.8.8 0 11.794 1.39l-.997.569v1.136a.8.8 0 01-1.6 0V8.465l-.997-.57a.8.8 0 01-.298-1.091zM1.4 8.8a.8.8 0 01.8.8v1.136l.997.57a.8.8 0 01-.794 1.39l-1.4-.8A.8.8 0 01.6 11.2V9.6a.8.8 0 01.8-.8zM12.6 8.8a.8.8 0 01.8.8v1.6a.8.8 0 01-.403.695l-1.4.8a.8.8 0 01-.794-1.389l.997-.57V9.601a.8.8 0 01.8-.8zM4.905 13.204a.8.8 0 011.092-.298l.203.116v-.221a.8.8 0 011.6 0v.221l.203-.116a.8.8 0 01.794 1.39l-1.388.792a.796.796 0 01-.818 0l-1.388-.793a.8.8 0 01-.298-1.091z",
    fill: "#000",
    fillOpacity: 0.3
  })));
}

export default SvgWeb3;